import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from '../_services/document.services';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';
import { Category, User } from '../_models';
import { AppConfig } from 'src/assets/config/config/app-config';
import { UsersAndGroupsService } from '../_services/users-and-groups.service';

@Component({
  selector: 'app-fileinbox',
  templateUrl: './fileinbox.component.html',
  styleUrls: ['./fileinbox.component.scss']
})

export class FileinboxComponent implements OnInit {
  fileUploaded: boolean = false;
  azureHeader: any
  docId: string;
  isFile: boolean = false;
  fileToUpload: FileList = null;
  progressInfos = [];
  fileInfos: Observable<any>;
  message = '';
  refreshClue: any = null;
  currentUser: User;
  groupList: any;
  userGroups: string[];
  categories: Category[];
  myFilesList: any[];
  teamFilesList: any[];
  duplicateList: any[];
  display: boolean = false;
  reload: boolean = false;
  isDuplicateAvailable = false;
  aclGroup: any = this.config.getACLGroup();
  isAdmin: boolean = false;


  constructor(
    private documentService: DocumentService,
    private authenticationService: AuthenticationService,
    private usersGroupsService: UsersAndGroupsService,
    private config: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.userGroups = authenticationService.userGroupsValue; 
    this.usersGroupsService.getAdminGroupName().subscribe((admin:any) => {
      for (let i = 0; i < this.userGroups.length; i++) {
          if (admin.indexOf(this.userGroups[i]) >= 0) {
              this.isAdmin = true;
              break;
          }
      }
    });
  }

  ngOnInit(): void {
    // this.getDocuments();
    //this.getDuplicates();
    this.display = true;
  }

  getDocuments() {
    this.documentService.getAllCaptureDocuments()
      .subscribe(docs => {
        if (docs == "You don't have access to any documents") {
          this.myFilesList = [];
          this.teamFilesList = [];
          this.display = true;
        } else if (docs == "No documents found") {
          this.myFilesList = [];
          this.teamFilesList = [];
          this.display = true;
        } else {
          this.myFilesList = [];
          this.teamFilesList = [];
          docs.forEach(doc => {
            if (this.currentUser.username === doc.owner) {
              this.myFilesList.push(doc);
            }
            else if (this.userGroups.includes(doc.owner)) {
              this.teamFilesList.push(doc);
            }
          })
          this.display = true;
        }
      });
  }

  getDuplicates() {
    this.documentService.getDuplicates()
      .subscribe(docs => {        
        if (docs && docs.length > 0) {
          this.isDuplicateAvailable = true;
        }
       
        this.duplicateList = docs;
        this.display = true;        
      });
  }

  refreshInbox(event) {
    this.getDocuments();
  }

  refreshDuplicate(event) {
    this.getDuplicates();
  }

  onReload(reload: boolean) {
    if (reload) {
      this.reload = true;
      this.getDocuments();
    } else {
      this.reload = false;
    }
  }
}